import api from "../../api";
import LoggerController from "../../controllers/Logger/LoggerController";
import { INIT_STEPDATA } from "../../reducers/StepState/action-types";
import { BROKER_TYPES } from "../../types/types";
import DeviceController from "../../utils/controllers/DeviceController";
import { brokerTypeFromString } from "../../utils/helpers";
import sendDataToCrawler from "../util/sendDataToCrawler";
import { dedupeByKey } from "../util/util";
import * as actions from "./action-types";

export function initParams(studyId, accessCode) {
  let payload = { studyId, accessCode, originalLink: window.location.href };

  return {
    type: actions.INIT_PARAMS,
    payload,
  };
}

export function initURLParams() {
  let payload = {};
  let search = window.location.search;

  if (search.includes("redirect_override=")) {
    let searches = [];
    let redirectUrl = "";

    if (search.includes("?redirect_override=")) {
      searches = search.split("?redirect_override=");
      search = "";
      redirectUrl = searches[1];
    } else {
      searches = search.split("&redirect_override=");
      search = searches[0];
      redirectUrl = searches[1];
    }

    payload["redirectOverride"] = redirectUrl;
  }

  const urlParams = new URLSearchParams(search);

  payload["participant"] = urlParams.get("participant");
  payload["showGaze"] = urlParams.get("show_gaze") === "1" ? true : false;
  payload["panelExtra1"] = urlParams.get("panel_extra1");
  payload["cellId"] = urlParams.get("cell_id");
  payload["panel"] = urlParams.get("panel");

  //when test=2 we skip the splash pages but still count the study as a test (exclude data)
  payload["testType"] = urlParams.get("test");
  payload["test"] =
    urlParams.get("test") === "1" ||
    urlParams.get("test") === "2" ||
    urlParams.get("test") === "3" ||
    urlParams.get("test") === "4"
      ? true
      : false;
  // Show "skip survey" for test types 1 & 3
  payload["showTestUserPage"] = (
    urlParams.get("test") === "1" || 
    urlParams.get("test") === "3"
  ) ? 1 : 0;

  if (urlParams.get("test") === "1") {
    payload["eyetrackingVersionOverride"] = DeviceController.getIsMobile() ? BROKER_TYPES.MOBILEMOUSE : BROKER_TYPES.MOUSE;
  }

  payload["eyetrackingVersionOverride"] = urlParams.get("et_type") ? brokerTypeFromString(urlParams.get("et_type")) : payload["eyetrackingVersionOverride"];

  return {
    type: actions.INIT_URL_PARAMS,
    payload,
  };
}

export function trackingStartTime(payload) {
  return {
    type: actions.TRACKING_START_TIME,
    payload: payload,
  };
}

// maybe fully deprecated?
export function updateInternalDemographicsQuestions(payload) {
  return {
    type: actions.UPDATE_INTERNAL_DEMOGRAPHICS_QUESTIONS,
    payload: payload,
  };
}

export function updateInternalDemographicsResponses(payload) {
  return {
    type: actions.UPDATE_INTERNAL_DEMOGRAPHICS_RESPONSES,
    payload: payload,
  };
}

export function calibrationInfo(payload) {
  return {
    type: actions.CALIBRATION_INFO,
    payload: payload,
  };
}

export function updateStepData(payload) {
  return {
    type: actions.UPDATE_STEP_DATA,
    payload: payload,
  };
}

export function regionCheck(testType) {
  return async function startRegionCheck(dispatch, getState) {
    let regionList = [
      { code: "ap", name: "ap-northeast-1" },
      { code: "sa", name: "sa-east-1" },
      { code: "sp", name: "ap-southeast-1" },
      { code: "us", name: "us-east-1" },
      { code: "us2", name: "us-west-2" },
      { code: "eu", name: "eu-west-2" },
    ];

    let promises = regionList.map((region) => api.misc.regionCheck(region));

    let actual_region = await api.misc.actualRegion();

    if (testType === "all") {
      let results = await Promise.all(promises);
      let min_response = Math.min(
        ...results.map((result) => result.timeTaken_ms)
      );
      let min_region = results.filter(
        (result) => result.timeTaken_ms === min_response
      )[0];
      let payload = {
        routedRegion: actual_region.region,
        fastestRegion: min_region.name,
        data: results,
      };
      dispatch({ type: actions.REGION_CHECK, payload });
      return payload;
    } else {
      let result = await Promise.race(promises);
      let payload = {
        routedRegion: actual_region.region,
        fastestRegion: result.name,
        data: result,
      };
      dispatch({ type: actions.REGION_CHECK, payload });
      return payload;
    }
  };
}

export function updateExtraData(payload) {
  return {
    type: actions.UPDATE_EXTRA_DATA,
    payload: payload,
  };
}

export function completePrestartChecks() {
  return { type: actions.PRESTART_CHECKS_COMPLETE };
}

export function completeStartChecks() {
  return { type: actions.START_CHECKS_COMPLETE };
}

export function completeInstructionsChecks() {
  return { type: actions.INSTRUCTIONS_CHECKS_COMPLETE };
}

export function surveyCompleted() {
  return { type: actions.SET_SURVEY_COMPLETE, payload: true };
}

export function updateSocialSessionData(payload) {
  return { type: actions.UPDATE_SOCIAL_SESSION_DATA, payload: payload };
}

export function updateSurveyUrlParams(payload) {
  return { type: actions.UPDATE_SURVEY_URL_PARAMS, payload: payload };
}
export function toggleExtendedLogger() {
  return { type: actions.TOGGLE_EXTENDED_LOGGER };
}

export function toggleSkipSurvey() {
  return { type: actions.TOGGLE_SKIP_SURVEY };
}
